/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TreeViewLarge } from './tree-view-large.story';
export { default as TreeViewLazyLoading } from './tree-view-lazy.story';
export { default as TreeViewMultiSelect } from './tree-view-multi.story';
export { default as TreeViewMultipleReplace } from './tree-view-multiple-replace.story';
export { default as TreeViewNonSelectableFolders } from './tree-view-non-selectable-folders.story';
export { default as TreeViewRootSelection } from './tree-view-root-selection.story';
export { default as TreeViewSingleSelect } from './tree-view-single.story';
export { default as TreeViewWithActions } from './tree-view-actions.story';
export { default as TreeViewUncontrolledExpansion } from './tree-view-uncontrolled.story';
export { default as TreeViewWithTrailingContent } from './tree-view-trailing.story';
export { default as TreeViewWithTooltip } from './tree-view-tooltip.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import TreeViewActionsSrcRaw from './tree-view-actions.story?raw';
import TreeViewLargeSrcRaw from './tree-view-large.story?raw';
import TreeViewLazyLoadingSrcRaw from './tree-view-lazy.story?raw';
import TreeViewMultiSelectSrcRaw from './tree-view-multi.story?raw';
import TreeViewMultipleReplaceSrcRaw from './tree-view-multiple-replace.story?raw';
import TreeViewNonSelectableFoldersSrcRaw from './tree-view-non-selectable-folders.story?raw';
import TreeViewRootSelectionSrcRaw from './tree-view-root-selection.story?raw';
import TreeViewSingleSelectSrcRaw from './tree-view-single.story?raw';
import TreeViewTooltipSrcRaw from './tree-view-tooltip.story?raw';
import TreeViewTrailingContentSrcRaw from './tree-view-trailing.story?raw';
import TreeViewUncontrolledExpansionSrcRaw from './tree-view-uncontrolled.story?raw';

export const TreeViewActionsSrc = removeLicenseHeader(TreeViewActionsSrcRaw);
export const TreeViewLargeSrc = removeLicenseHeader(TreeViewLargeSrcRaw);
export const TreeViewLazyLoadingSrc = removeLicenseHeader(
  TreeViewLazyLoadingSrcRaw,
);
export const TreeViewMultiSelectSrc = removeLicenseHeader(
  TreeViewMultiSelectSrcRaw,
);
export const TreeViewMultipleReplaceSrc = removeLicenseHeader(
  TreeViewMultipleReplaceSrcRaw,
);
export const TreeViewNonSelectableFoldersSrc = removeLicenseHeader(
  TreeViewNonSelectableFoldersSrcRaw,
);
export const TreeViewRootSelectionSrc = removeLicenseHeader(
  TreeViewRootSelectionSrcRaw,
);
export const TreeViewSingleSelectSrc = removeLicenseHeader(
  TreeViewSingleSelectSrcRaw,
);
export const TreeViewTrailingContentSrc = removeLicenseHeader(
  TreeViewTrailingContentSrcRaw,
);
export const TreeViewTooltipSrc = removeLicenseHeader(TreeViewTooltipSrcRaw);
export const TreeViewUncontrolledExpansionSrc = removeLicenseHeader(
  TreeViewUncontrolledExpansionSrcRaw,
);
